import Container from "@/components/common/Container";
import ProjectMaintenanceCard from "@/components/common/ProjectMaintenanceCard";

const DevelopmentProcess = (data) => {
  const { developmentProcessData, title, description } =
    data.developmentProcess;
  return (
    <Container large className="bg-primary-black">
      <h2 className="text-4xl leading-snug md:text-3xl lg:text-6xl mb-10 md:mb-0 md:pb-7 font-medium text-white">
        <span>{title}</span>
      </h2>
      <p className="text-base font-normal text-white text-justify mb-0 lg:w-3/4">
        <span>{description}</span>
      </p>
      <div className="pt-10 pb-36 md:pb-20 lg:pt-24 lg:pb-40 w-fit mx-auto">
        {developmentProcessData.map((values, index) => (
          <ProjectMaintenanceCard
            key={values.leftText}
            hidden={index === 3}
            {...{ ...values, index, length: developmentProcessData.length }}
          />
        ))}
      </div>
    </Container>
  );
};
export default DevelopmentProcess;
